
import { environment } from '../../../environments/environment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Component, OnInit, OnDestroy, ElementRef, } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { User, Role } from '../../../app/_models';
import { AuthenticationService, EmpresaService, KtidentityMfaChallenge, KtidentityService, RoleService, UserService } from '../../../app/_services';
import { ToastrService } from 'ngx-toastr';
import { Form } from '@angular/forms';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { RealtimeService } from '../../_services/realtime.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PasswordInputComponent } from '../../_shared/password-input/password-input.component';
import { KtidentityMfaComponent } from '../../_shared/ktidentity-mfa/ktidentity-mfa.component';
import { AUTH_ERROR_CODES, AUTH_ERROR_MESSAGES, KTIDENTITY_ERROR_KEYS } from '../../_shared/auth-error-codes';

interface LoginAlertConfig {
  icon: 'error' | 'warning' | 'info' | 'success';
  titleKey: string;
  textKey?: string;
}

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, BsDropdownModule, RouterModule, PasswordInputComponent, KtidentityMfaComponent],
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  private realizandoLogin = false;
  // Translate
  externallogin = ''
  listLanguages = ["es", "pt", "en"]
  flag: string = "";
  lang: string = "pt";
  flags: { [key: string]: string } = {
    "pt": "/assets/icon/flag/pt.svg",
    "en": "/assets/icon/flag/en.svg",
    "es": "/assets/icon/flag/es.svg",
    "fr": "/assets/icon/flag/french.svg"
  };

  public user: User | undefined;
  private returnUrl: string = '';
  form: Form | undefined;
  url: string= '';
  showLoginBox = true;
  // botão "Entrar com KTIdentity": só para KT Group (mesma flag do "Desenvolvido por") e quando o backend diz que o login está ligado
  ktidentityEnabled = false;
  ktidentityLabel = '';
  // desafio do MFA em andamento (com o segredo do primeiro acesso): só em memória, descartado ao fechar o modal
  ktidentityChallenge: KtidentityMfaChallenge | null = null;
  ktidentityEmail = '';
  logoSrc = environment.logo.large;
// "Desenvolvido por": oculto por padrão; habilite com showDevelopedBy: true no environment
showDevelopedBy = !!(environment as { showDevelopedBy?: boolean }).showDevelopedBy;

  // Mapa único de mensagens de erro do backend -> {icon, título, texto} para a tela de
  // login, evitando repetir o mesmo bloco Swal.fire em cada ramo do if/else.
  private readonly loginSuccessAlerts: Record<string, LoginAlertConfig> = {
    [AUTH_ERROR_MESSAGES.INCORRECT_USERNAME_OR_PASSWORD]: { icon: 'error', titleKey: 'LOGIN.invalidPassword' },
    [AUTH_ERROR_MESSAGES.TEMPORARY_PASSWORD_EXPIRED]: {
      icon: 'error',
      titleKey: 'LOGIN.yourTemporaryPasswordExpired',
      textKey: 'LOGIN.pleaseContactTheAdm'
    },
    [AUTH_ERROR_MESSAGES.USER_ALREADY_LOGGED_IN_ANOTHER_DEVICE]: {
      icon: 'error',
      titleKey: 'LOGIN.thisUserIsLoggedInAnotherDevice'
    },
    [AUTH_ERROR_MESSAGES.KTIDENTITY_ACCOUNT]: { icon: 'info', titleKey: 'LOGIN.ktidentity.useKtidentity' }
  };

  private readonly loginErrorAlerts: Record<string, LoginAlertConfig> = {
    [AUTH_ERROR_MESSAGES.TIMEOUT_OCCURRED]: { icon: 'error', titleKey: 'LOGIN.responseTimeExceeded' },
    [AUTH_ERROR_MESSAGES.USER_ALREADY_LOGGED_IN_ANOTHER_DEVICE]: {
      icon: 'error',
      titleKey: 'LOGIN.thisUserIsLoggedInAnotherDevice'
    },
    [AUTH_ERROR_MESSAGES.USER_NOT_REGISTERED_IN_SYSTEM]: { icon: 'error', titleKey: 'LOGIN.userNoRegisteredInSystem' }
  };

  private readonly defaultLoginErrorAlert: LoginAlertConfig = {
    icon: 'error',
    titleKey: 'LOGIN.thereWasAProblem'
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private notifierService: ToastrService,
    public dialog: MatDialog,
    private _elementRef: ElementRef,
    // private pubnubService: PubnubService, // Removido - substituído por RealtimeService
    private realtimeService: RealtimeService,
    private empresaService: EmpresaService,
    private userService: UserService,
    private modalService: BsModalService,
    private roleService: RoleService,
    public translate: TranslateService,
    private ktidentityService: KtidentityService,
  ) {
    this.user = new User();
    this.initializeLanguage(translate);
  }



  public ngOnInit() {
    // debugger;
    this.router.events.subscribe((event: any) => {
      if(event instanceof NavigationEnd) {
        const loader = document.getElementById('loader');
        if(loader) {
          loader.style.display = 'none';
        }
      }
    });
    window.dispatchEvent(new Event('resize'));
    document.body.className = 'hold-transition login-page';
    // tslint:disable-next-line: max-line-length
    if (this.authService.currentUserValue && (this.authService.currentUserValue['token'] && this.authService.currentUserValue['selectedEmpresa'])) {
      this.router.navigate(['/home']);
    }
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
    if (this.route.snapshot.queryParams['reset'] === 'ok') {
      // volta da página de nova senha do KTIdentity
      this.showAlert({ icon: 'success', titleKey: 'LOGIN.ktidentity.passwordResetOk' });
    }
    this.form = this._elementRef.nativeElement.querySelector(`#myform`);
    this.url = environment.baseUrl + '/sso/authorize';
    const check = window.location.pathname.includes('loginatvos')
    const check2 = window.location.pathname.includes('loginallianz')
    const check3 = window.location.pathname.includes('logintokio')
    const check4 = window.location.pathname.includes('logindocsia')
    if (! (check || check2 || check3 || check4) ) {
      this.showLoginBox = true;
      // this.externallogin = 'atvos'
      if (this.showDevelopedBy) {
        this.ktidentityService.status().subscribe(status => {
          this.ktidentityEnabled = status.enabled;
          this.ktidentityLabel = status.label || 'KTIdentity';
        });
      }
    }
    else {
      if(check) {
        this.externallogin = 'atvos'
      } else if(check2) {
        this.externallogin = 'allianz'
      } else if(check3) {
        this.externallogin = 'tokio'
      }else if(check4) {
        this.externallogin = 'docsia'
      }
      this.showLoginBox = false;
      this.route.queryParams.subscribe(async (params: any) => {
        // console.log(params);
        const error = params.error;
        if(error) {
          Swal.fire({
            title: error,
            icon: 'error',
            showCancelButton: false,
            cancelButtonText: this.translate.instant('LOGIN.close')
          });
        }
        else {
          const token = params.token;
          console.log("TOKEN: ",token);
          if(token) {
            // autenticacao via sso
            // ATENCAO - endereço de login está Hard Coded. implementar um mecanismo de busca a urlLogin de empresas
            await this.authService.inicialize()
            if(this.externallogin === 'atvos') {
              this.authService.currentLoginPathSubject.next('/loginatvos');
            } else if(this.externallogin === 'allianz') {
              this.authService.currentLoginPathSubject.next('/loginallianz');
            } else if(this.externallogin === 'tokio') {
              this.authService.currentLoginPathSubject.next('/logintokio');
            } else if(this.externallogin === 'docsia') {
              this.authService.currentLoginPathSubject.next('/logindocsia');
            }
            localStorage.setItem('token', token);
            const user = this.authService.currentUserValue;
            user.token = token;
            this.authService.currentUserSubject.next(user);
            // console.log('continuar daqui...');
            // buscar o user no mongo
            let myuser:any = await this.userService.getByToken(token);
            // console.log(myuser);
            myuser = new User(myuser)
            // localStorage.setItem('currentUser', JSON.stringify(myuser));
            // avisa a todos os subscriber o novo status...
            myuser.token = token;
            this.authService.isLoginSubject.next(true);
            this.authService.currentUserSubject.next(myuser);
            // verificando permissões
            if(!myuser.approved && myuser.email) {
              Swal.fire({
                title: this.translate.instant('LOGIN.waitingApproveForAdm'),
                icon: 'warning',
                showCancelButton: false,
                cancelButtonText: this.translate.instant('LOGIN.close'),
              });
            } else if(myuser.message === AUTH_ERROR_MESSAGES.USER_ALREADY_LOGGED_IN_ANOTHER_DEVICE) {
              Swal.fire({
                title: this.translate.instant('LOGIN.thisUserIsLoggedInAnotherDevice'),
                icon: 'error',
                showCancelButton: false,
                cancelButtonText: this.translate.instant('LOGIN.close'),
              });
            } else {
              this.prepareUserAfterLogged(myuser);
            }
          }
        }
      }, (error)=>{
        console.error(error);
      });
    }
  }
  change(empresas: any) {
    this.userService.change(empresas, '');
  }
  public ngOnDestroy() {
    document.body.className = '';
  }
  public login() {
    if (this.realizandoLogin){
      return
    }
    this.realizandoLogin = true;
    const self = this;

    if ((this.user?.email === '') || (!this.user?.hasOwnProperty('password') || this.user?.password === '')) {
      this.realizandoLogin = false;
      this.showAlert({ icon: 'error', titleKey: 'LOGIN.userOrPasswordEmpty' });
    } else {
      this.authService.login(this.user?.email || '', this.user?.password || '')
        .subscribe((data: any) => {
            // autenticação feita pelo fluxo normal de login
            this.authService.currentLoginPathSubject.next('/login');
            if(!data.approved && data.email) {
              this.showAlert({ icon: 'warning', titleKey: 'LOGIN.waitingApproveForAdm' });
            } else if(data.message === AUTH_ERROR_MESSAGES.NEW_PASSWORD_REQUIRED) {
              this.realizandoLogin = false;
              this.router.navigate(['/changePassword']);
            } else if(data.message && this.loginSuccessAlerts[data.message]) {
              this.realizandoLogin = false;
              this.showAlert(this.loginSuccessAlerts[data.message]);
            } else {
              // crie um metodo englobando todo esse codigo
              this.prepareUserAfterLogged(data);

            }
          },
          error => {
            this.realizandoLogin = false;
            if('error' in error && error.error.code === AUTH_ERROR_CODES.NOT_AUTHORIZED) {
              this.showAlert({ icon: 'error', titleKey: 'LOGIN.invalidPassword' });
            } else {
              const messageKey = error.message === AUTH_ERROR_MESSAGES.TIMEOUT_OCCURRED ? error.message : error?.error?.message;
              this.showAlert((messageKey && this.loginErrorAlerts[messageKey]) || this.defaultLoginErrorAlert);
            }
          }
        );
    }
  }

  // Login com KTIdentity: mesmo e-mail e senha do formulário, enviados ao backend que fala com o Identity
  public loginKtidentity() {
    if (this.realizandoLogin) {
      return;
    }
    const email = this.user?.email || '';
    const password = this.user?.password || '';
    if (email === '' || password === '') {
      this.showAlert({ icon: 'error', titleKey: 'LOGIN.userOrPasswordEmpty' });
      return;
    }
    this.realizandoLogin = true;
    this.ktidentityEmail = email;
    this.ktidentityService.login(email, password).subscribe(result => {
        this.realizandoLogin = false;
        if (result.kind === 'mfa') {
          this.ktidentityChallenge = result.challenge;
          return;
        }
        this.onKtidentityCompleted(result.user);
      },
      error => {
        this.realizandoLogin = false;
        this.showKtidentityError(error?.error?.code);
      }
    );
  }

  public onKtidentityCompleted(user: User) {
    this.ktidentityChallenge = null;
    this.authService.currentLoginPathSubject.next('/login');
    this.prepareUserAfterLogged(user);
  }

  // erro que não é "código inválido" fecha o modal e aparece no formulário
  public onKtidentityFailed(code: string) {
    this.ktidentityChallenge = null;
    this.showKtidentityError(code);
  }

  public onKtidentityCancelled() {
    this.ktidentityChallenge = null;
  }

  private showKtidentityError(code: string | undefined) {
    const titleKey = (code && KTIDENTITY_ERROR_KEYS[code]) || this.defaultLoginErrorAlert.titleKey;
    const reason = code === 'too_many_login_attempts' ? 'locked' : code === 'password_expired' ? 'expired' : '';
    if (!reason) {
      // vínculo da conta do Cognito pendente de confirmação por e-mail: aviso, não erro
      const linkPending = code === 'account_link_required' || code === 'account_link_already_sent';
      this.showAlert({ icon: linkPending ? 'warning' : 'error', titleKey });
      return;
    }
    // bloqueio e senha vencida só se resolvem redefinindo a senha no Identity
    Swal.fire({
      title: this.translate.instant(titleKey),
      icon: 'error',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('LOGIN.ktidentity.resetPassword'),
      cancelButtonText: this.translate.instant('LOGIN.close'),
    }).then(result => {
      if (result.isConfirmed) {
        this.router.navigate(['/pages/recovery'], {
          queryParams: { provider: 'ktidentity', email: this.ktidentityEmail || this.user?.email || '', reason, auto: '1' }
        });
      }
    });
  }

  private showAlert(config: LoginAlertConfig) {
    Swal.fire({
      title: this.translate.instant(config.titleKey),
      text: config.textKey ? this.translate.instant(config.textKey) : undefined,
      icon: config.icon,
      showCancelButton: false,
      cancelButtonText: this.translate.instant('LOGIN.close'),
    });
  }

  initializeLanguage(translate: TranslateService) {
    // debugger
    var userLang = navigator.language || (navigator as any).userLanguage;
    var sessionLanguage = localStorage.getItem("lang") || 'pt';
    translate.addLangs(['en', 'pt', 'es', 'fr']);
    let user = userLang.startsWith('en') ? 'en' : userLang.includes('es') ? 'es' : 'pt';
    this.lang = sessionLanguage;

    if(sessionLanguage) {
      this.flag = this.flags[sessionLanguage];
      translate.setDefaultLang(sessionLanguage);
    } else if ((user as any)["value"]) {
      this.flag = this.flags[(user as any)["lang"]];
      translate.setDefaultLang((user as any)["lang"]);
      localStorage.setItem("lang", (user as any)["lang"]);
    } else {
      this.flag = this.flags["pt"];
      translate.setDefaultLang("pt");
      localStorage.setItem("lang", "pt");
    }
  }

  changLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem("lang", lang);
    let essaFLag = document.querySelector(".flag button img") as HTMLImageElement;
    if (essaFLag) {
      essaFLag.setAttribute("src", this.flags[lang]);
    }

    this.lang = lang;
  }

  makeLogout(title: any) {
    this.authService.logout().subscribe((res: any) => {
        Swal.fire({
          title: title,
          icon: 'error',
          showCancelButton: false,
          cancelButtonText: this.translate.instant('LOGIN.close'),
        });
      },
      error => {
        Swal.fire({
          title: title,
          icon: 'error',
          showCancelButton: false,
          cancelButtonText: this.translate.instant('LOGIN.close'),
        });
        this.notifierService.clear();
        this.notifierService.error(error.Message || error.message || error.statusText); // , error.message || error.statusText
      });
  }
  prepareUserAfterLogged(data: any) {
    const currentUser = this.authService.currentUserValue;
    console.log("iniciando preparacação do usuário: ", currentUser);
    if(data.message === AUTH_ERROR_MESSAGES.USER_DOES_NOT_EXIST) {
      Swal.fire({
        title: `${this.translate.instant('LOGIN.user')} ${currentUser?.email} ${this.translate.instant('LOGIN.notExist')}`,
        icon: 'error',
        showCancelButton: false,
        cancelButtonText: this.translate.instant('LOGIN.close'),
      });
    } else {
      // verificando se o usuário está associado a alguma ambiente empresarial:
      if(currentUser && 'empresas' in currentUser && currentUser?.empresas?.length === 0) {
        this.authService.logout().subscribe((res: any) => {
            // console.log('Usuário deslogado.');
            Swal.fire({
              title: this.translate.instant('LOGIN.userNotAssociedBusiness'),
              icon: 'error',
              showCancelButton: false,
              cancelButtonText: this.translate.instant('LOGIN.close'),
            });
          },
          error => {
            this.notifierService.clear();
            this.notifierService.error(error.message || error.statusText); // , error.message || error.statusText
          });
      } else {
        // verifica se o usuário é masterAdmin
        if(currentUser?.masterAdmin) {
          this.change(null); // Selecao de ambiente empresarial
          this.authService.currentUserSubject.next(currentUser);
          this.userService.updateMongo(currentUser).subscribe((data: any) => {
            // console.log(data);
          });
        } else if(currentUser?.isAdmin) {
          //usuário admin. só pode estar associado a um ambiente empresarial
          if (currentUser?.empresas && currentUser.empresas.length > 0) {
            currentUser.selectedEmpresa = currentUser.empresas[0];
          }
          if(currentUser?.selectedEmpresa?.empresas && currentUser.selectedEmpresa.empresas.length > 0) {
            this.change([currentUser.selectedEmpresa]); // Selecao de empresas no mesmo ambiente
            this.authService.currentUserSubject.next(currentUser);
            this.userService.updateMongo(currentUser).subscribe((data: any) => {
              // console.log(data);
            });
          } else {
            // unica empresa cadastrada. redireciona para Home
            this.authService.currentUserSubject.next(currentUser);
            this.userService.updateMongo(currentUser).subscribe((data: any) => {
              this.router.navigate([this.returnUrl]);
            });
          }
        } else {
          // usuário comum. só pode estar associado a um ambiente empresarial
          if (currentUser?.empresas && currentUser.empresas.length > 0) {
            currentUser.selectedEmpresa = currentUser.empresas[0];
          }
          // setando a variavel seletctedAcvtivity

          let roleEmpresaId: any = currentUser?.selectedEmpresa?._id;
          if(currentUser?.selectedEmpresa?.hasRole) {
            // verifica se o usuário tem perfil de acesso
            if(currentUser?.selectedEmpresa?.idMatriz) {
              // usuário é de uma filial.
              roleEmpresaId = currentUser?.selectedEmpresa?.idMatriz;
            }
            this.roleService.getAll(roleEmpresaId).subscribe((roles: Role[]) => {
              if(roles.length > 0) {
                // tudo ok. empresa tem perfil de acesso.
                // verifica se o usuário está associado a algum perfil
                let check = false;
                let userRoles: any[] = [];
                roles.forEach((role: any) => {
                  role.users.forEach((user: any) => {
                    if(user._id === currentUser?._id) {
                      check = true;
                      userRoles.push(role);
                    }
                  });
                });
                if(check) {
                  // ativando pefil primário do usuário
                  currentUser.selectedRole = userRoles[0];
                  // sessionStorage (isolado por aba, evita uma aba trocar o contexto de
                  // outra) + JSON.stringify (sem isso o guard lia "[object Object]" e a
                  // checagem de perfil/atividade ficava sempre desativada).
                  sessionStorage.setItem("selectedRole", JSON.stringify(userRoles[0]));
                  if(currentUser.selectedRole.empresas.length === 0) {
                    this.makeLogout(this.translate.instant('LOGIN.profileWithoutBusiness'));
                  } else if(currentUser.selectedRole.empresas.length === 1) {
                    // só existe uma única empresa
                    currentUser.selectedEmpresa = currentUser.selectedRole.empresas[0];
                    this.authService.currentUserSubject.next(currentUser);
                    currentUser.selectedRole.activities.forEach((activity: any) => {
                      if(activity.empresa_id === currentUser.selectedEmpresa!._id) {
                        currentUser.selectedActivity = activity;
                      }
                    });
                    this.userService.updateMongo(currentUser).subscribe((data: any) => {
                      this.router.navigate([this.returnUrl]);
                    });
                  } else {
                    // usuário tem perfil de acesso a mais de uma empresa
                    this.change(currentUser.selectedRole.empresas); // seleção de empresas por perfil
                    this.authService.currentUserSubject.next(currentUser);
                    this.userService.updateMongo(currentUser).subscribe((data: any) => {
                      // console.log(data);
                    });
                  }
                } else {
                  // usuário não tem perfil de acesso
                  this.makeLogout(this.translate.instant('LOGIN.userDoesNotAcessProfile'));
                }
              } else {
                // empresa sem perfil de acesso
                // tslint:disable-next-line: max-line-length
                this.makeLogout(this.translate.instant('LOGIN.companyWichUserStillDoesNotHaveAccess'));
              }
            });
          } else {
            // empresa não cadastrada para ter role.
            if (currentUser.empresas.length > 1 || (currentUser.empresas.length == 1 && (currentUser.empresas[0].empresas.length > 0))) {
              this.change(currentUser.empresas); // Selecao de empresas no mesmo ambiente
              this.userService.updateMongo(currentUser).subscribe((data: any) => {
                // console.log(data);
              });
              // this.userService.changeCompany();
            } else if(currentUser.empresas.length == 1) {
              // empresa selecionada é a unica empresa do ambiente redireciona para HOME
              this.authService.setCurrentUser(currentUser);
              this.userService.updateMongo(currentUser).subscribe((data: any) => {
                // localStorage.setItem('currentUser', JSON.stringify(currentUser));
                this.router.navigate([this.returnUrl]);
              });
            } else {
              Swal.fire({
                title: this.translate.instant('LOGIN.userNotRegisteredWithCompany'),
                icon: 'error',
                showCancelButton: false,
                cancelButtonText: this.translate.instant('LOGIN.close'),
              });
            }
          }
        }
      }
    }
  }
  
  public authorization_external_provider() {
    const self = this;
    // http://localhost:3000/api/sso/token
    // ATENCAO - provider name está Hard Coded. implementar um mecanismo de busca de provider pelo nome
    if(this.externallogin === 'atvos') {
      const domain = environment.baseUrl + '/sso/token';
      const myurl = 'https://docsia-auth.auth.us-east-1.amazoncognito.com/oauth2/authorize?identity_provider=AzureADAtvos&redirect_uri=' + domain + '&response_type=CODE&client_id=2b1k88a07db93fb5uu5gi1qja8&scope=email openid'
      window.location.href = myurl;
    } else if(this.externallogin === 'allianz') {
      const domain = environment.baseUrl + '/sso/tokenallianz';
      const myurl = 'https://docsia-auth.auth.us-east-1.amazoncognito.com/oauth2/authorize?identity_provider=allianz-ktgroup-identity&redirect_uri=' + domain + '&response_type=code&client_id=10bhh512tjug3n9lpg6uihct6i&scope=email%20profile%20openid'
      window.location.href = myurl;
    } else if(this.externallogin === 'tokio') {
      const domain = environment.baseUrl + '/sso/token?adlogin=tokio';
      const myurl = `${environment.domainAuth}/oauth2/authorize?identity_provider=EntraID&redirect_uri=` + domain + `&response_type=code&client_id=${environment.sso.clientId}&scope=email%20openid`
      window.location.href = myurl;
    }else if(this.externallogin === 'docsia') {
      const domain = environment.baseUrl + '/sso/token?adlogin=docsia';
      const myurl = `${environment.domainAuth}/oauth2/authorize?identity_provider=test-keycloak&redirect_uri=${domain}&response_type=code&client_id=${environment.sso.clientId}&scope=email%20openid`
      window.location.href = myurl;
    }
  }
}
